import PaymentSelector from './PaymentSelector';

export default PaymentSelector;
